import { Ref, ref, computed } from "vue";
import { useStore } from "vuex";
export default function useCheckAll(items: Ref<any[]>, totalItem: Ref<any>, isMember = false, key = "id") {
  const elem = ref<any[]>(items.value);
  const arrSelected = ref<number[]>([]);
  const arrUnselected = ref<number[]>([]);
  const allSelected = ref<boolean>(false);
  const store = useStore();
  const userId = computed(() => store.getters.getUserId);

  const onCheckAllChange = () => {
    arrSelected.value = [];
    arrUnselected.value = [];
    if (allSelected.value) {
      elem.value.forEach((it: any) => {
        if (isMember) {
          if (it.role.id == 1 || it[key] == userId.value) {
            arrUnselected.value.push(it[key] as number);
          } else {
            arrSelected.value.push(it[key] as number);
          }
        } else {
          arrSelected.value.push(it[key] as number);
        }
      });
    }
  };

  const onSelectItem = (id: number) => {
    if (allSelected.value) {
      if (!arrUnselected.value.includes(id)) {
        arrUnselected.value.push(id);
        const index = arrSelected.value.indexOf(id);
        if (index !== -1) {
          arrSelected.value.splice(index, 1);
        }
        if (arrUnselected.value.length == totalItem.value) {
          allSelected.value = false;
          arrUnselected.value = [];
        }
      } else {
        const index = arrUnselected.value.indexOf(id);
        if (index !== -1) {
          arrUnselected.value.splice(index, 1);
        }
      }
    } else {
      if (arrSelected.value.length == totalItem.value) {
        allSelected.value = true;
      }
    }
  };

  const setCheckAllList = (list: Ref<any[]>) => {
    elem.value = list.value || [];
    resetCheckAll();
  };

  const resetCheckAll = () => {
    if (allSelected.value) {
      arrSelected.value = [];
      elem.value.forEach((it: any) => {
        if (!arrUnselected.value.includes(it[key])) {
          if (isMember) {
            if (it.role.id == 1 || it[key] == userId.value) {
              arrUnselected.value.push(it[key] as number);
            } else {
              arrSelected.value.push(it[key] as number);
            }
          } else {
            arrSelected.value.push(it[key] as number);
          }
        }
      });
    }
  };

  const removeCheckAll = () => {
    allSelected.value = false;
    arrSelected.value = [];
    arrUnselected.value = [];
  };

  return {
    arrSelected,
    arrUnselected,
    allSelected,
    onCheckAllChange,
    onSelectItem,
    setCheckAllList,
    resetCheckAll,
    removeCheckAll,
  };
}
